import {Component, OnInit, Signal, ChangeDetectionStrategy} from "@angular/core";
import {Router, RouterLink} from "@angular/router";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {environment} from "src/environments/environment";
import {AuthenticateService} from "src/app/services/authenticate.service";
import {PlatformService} from "src/app/services/platform.service";
import {DeviceDetectService} from "src/app/services/device-detect.service";
import {buildTechnicalFeedbackMailto} from "src/app/shared/utils/feedback-mailto.util";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, TranslatePipe],
})
export class FooterComponent implements OnInit {
  customerService = atob(environment.emails.customerService);
  sessionId: string = sessionStorage.getItem("sessionId")!;
  brandName!: Signal<string>;
  /** True when in paid-service flow, so we hide the second column (first links column) */
  isPaidServicesRoute!: Signal<boolean>;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private platformService: PlatformService,
    private authenticateService: AuthenticateService,
    private deviceDetectService: DeviceDetectService,
  ) {
    this.brandName = this.platformService.brandName;
    this.isPaidServicesRoute = this.platformService.isPaidByLandingFlow;
  }

  ngOnInit() {
    this.initializeSessionId();
  }

  private async initializeSessionId(): Promise<void> {
    if (sessionStorage.getItem('sessionId')!) return;
    await this.authenticateService.getSessionId();
    this.sessionId = sessionStorage.getItem('sessionId')!;
  }

  get mailToHref(): string {
    return buildTechnicalFeedbackMailto({
      email: this.customerService,
      sessionId: this.sessionId,
      translate: this.translate,
      deviceDetectService: this.deviceDetectService,
    });
  }
}
